import { render, staticRenderFns } from "./StatLine.vue?vue&type=template&id=fb31c224&"
import script from "./StatLine.vue?vue&type=script&lang=js&"
export * from "./StatLine.vue?vue&type=script&lang=js&"
import style0 from "./StatLine.vue?vue&type=style&index=0&id=fb31c224&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports